/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `en` - English
 * * `de` - Deutsch
 * * `pl` - Polski
 * * `tr` - Türkçe
 */
export enum LanguageEnum {
    EN = 'en',
    DE = 'de',
    PL = 'pl',
    TR = 'tr',
}
